import {InjectionToken} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {CountryCodeRepresentation} from './lib/metadata/country-info';

export const DEFAULT_COUNTRY = new InjectionToken<BehaviorSubject<CountryCodeRepresentation>>(
  'DEFAULT_COUNTRY'
);
